import styled from 'foundations-theming/utils';
import { getReferencePadding } from './ActionsMenu.helpers';
import { deepMerge } from '../../transitional/utils/deepMerge/deepMerge';
import { JUPITER_LAYER } from '../../transitional/constants';
export const StyledContainer = styled.div.withConfig({
  displayName: "ActionsMenustyles__StyledContainer",
  componentId: "sc-14y8ah4-0"
})(({
  $styleOverrides
}) => {
  return deepMerge({
    inlineSize: '100%'
  }, $styleOverrides);
});
export const StyledReferenceWrapper = styled.div.withConfig({
  displayName: "ActionsMenustyles__StyledReferenceWrapper",
  componentId: "sc-14y8ah4-1"
})(({
  theme,
  $referenceSize,
  $referenceLayout,
  $marginStyles
}) => {
  const inlineSize = $referenceLayout === 'indicator-only' ? 'fit-content' : '100%';
  const blockSize = $referenceSize === 'default' ? theme.space[1000] : theme.space[800];
  return Object.assign({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    inlineSize,
    blockSize
  }, $marginStyles);
});
export const StyledReferenceIndicator = styled.div.withConfig({
  displayName: "ActionsMenustyles__StyledReferenceIndicator",
  componentId: "sc-14y8ah4-2"
})(({
  theme,
  $referenceSize
}) => {
  const {
    paddingBlock
  } = getReferencePadding(theme);
  const referenceHeight = $referenceSize === 'default' ? theme.space[1000] : theme.space[800];
  return {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    blockSize: `calc(${referenceHeight} - ${paddingBlock} * 2)`,
    borderRadius: theme.borderRadius['full'],
    flexShrink: 0
  };
});
export const StyledReferenceText = styled.span.withConfig({
  displayName: "ActionsMenustyles__StyledReferenceText",
  componentId: "sc-14y8ah4-3"
})(({
  theme
}) => {
  return {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginInlineEnd: theme.space[200]
  };
});
export const StyledDownCaratIconWrapper = styled.span.withConfig({
  displayName: "ActionsMenustyles__StyledDownCaratIconWrapper",
  componentId: "sc-14y8ah4-4"
})(({
  $iconSize
}) => {
  return {
    display: 'flex',
    alignItems: 'center',
    opacity: 0.8,
    inlineSize: $iconSize,
    blockSize: $iconSize
  };
});
export const StyledMenu = styled.div.withConfig({
  displayName: "ActionsMenustyles__StyledMenu",
  componentId: "sc-14y8ah4-5"
})(({
  theme,
  $isReferenceHidden
}) => {
  return {
    visibility: $isReferenceHidden ? 'hidden' : 'visible',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    outline: 0,
    backgroundColor: theme.color['fill-surface-default'],
    borderRadius: theme.borderRadius[200],
    boxShadow: theme.boxShadow[300],
    zIndex: JUPITER_LAYER
  };
});
export const StyledMenuOptionsWrapper = styled.div.withConfig({
  displayName: "ActionsMenustyles__StyledMenuOptionsWrapper",
  componentId: "sc-14y8ah4-6"
})(({
  theme
}) => {
  return {
    borderRadius: 'inherit',
    flexGrow: 1,
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.color['fill-tertiary-pressed']} transparent`
  };
});
export const StyledMenuOption = styled.div.withConfig({
  displayName: "ActionsMenustyles__StyledMenuOption",
  componentId: "sc-14y8ah4-7"
})(({
  theme,
  $isActive,
  $disabled,
  $divider,
  $isSubheading
}) => {
  return Object.assign({
    paddingBlock: theme.space[300],
    paddingInline: theme.space[400],
    cursor: 'pointer',
    outline: 0
  }, $isSubheading && {
    padding: theme.space[200]
  }, $isActive && {
    backgroundColor: theme.color['fill-field-hover']
  }, $disabled && {
    cursor: 'not-allowed'
  }, !$disabled && {
    '&:active': {
      backgroundColor: theme.color['fill-tertiary-hover']
    }
  }, $divider && {
    borderBlockEndStyle: 'solid',
    borderBlockEndWidth: theme.space[25],
    borderBlockEndColor: theme.color['border-core-subtle']
  });
});
export const StyledMenuOptionContentWrapper = styled.button.withConfig({
  displayName: "ActionsMenustyles__StyledMenuOptionContentWrapper",
  componentId: "sc-14y8ah4-8"
})(({
  theme,
  $optionTextColor,
  $hasIndicator
}) => {
  return {
    background: 'none',
    font: 'inherit',
    cursor: 'inherit',
    outline: 'inherit',
    position: 'relative',
    border: 'none',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'flex',
    gap: $hasIndicator ? theme.space[200] : theme.space[0],
    color: theme.color[$optionTextColor]
  };
});
export const StyledMenuOptionIndicator = styled.span.withConfig({
  displayName: "ActionsMenustyles__StyledMenuOptionIndicator",
  componentId: "sc-14y8ah4-9"
})(({
  theme
}) => {
  return {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    height: theme.space[600],
    borderRadius: theme.borderRadius['full']
  };
});